module.exports = __webpack_public_path__ + "static/media/harikrushn.823352fd.jpg";